module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/envelope-a306c06dc5fc06374968aa2c16d4098a.svg";